import type { Appointment } from "@shyne/shared/api";
import { rowStatusOf } from "@/repositories/appointment-records";
import { isAssignable } from "./appointment-assignment";

export const needsAnAssignee = ({ status, assignment }: Appointment): boolean =>
  isAssignable(rowStatusOf(status)) && assignment.subcontractor === null && assignment.worker === null;
